import React from "react";

import {
   ADDITIONAL_DRIVING_QUALIFICATION_OPTIONS,
   DRIVING_LICENSE_DURATION_OPTIONS,
   DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST,
   DRIVING_LICENSE_TYPE_OPTIONS,
   DVLA_MEDICAL_CONDITION_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";

import DrivingLicenseNumber from "./parts/driving-license-number";
import {ValidateStep2Data} from "@validators/fast-food-delivery-insurance-form/step2-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import ScrollableCustomDateTimePickerBlock
   from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import PreviousButtonComponent from "@components/common/form-controls/buttons/previous-button";
import NextButtonComponent from "@components/common/form-controls/buttons/next-button";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";


export default function IF_Step2(
   {
      data,
      handlers,
      setCurrentStep,
      handlePolicyHolderAccidentPropChange,
      addPolicyHolderAccident,
      removePolicyHolderAccident,
   }
) {
   
   const onPrevBtnClick = (event) => {
      
      setCurrentStep(1);
      
   }
   
   function onNextBtnClick() {
      
      let validationResult = ValidateStep2Data(data);
      
      /*validationResult.push({
          name : 'halt',
          message : 'Halt further processing'
      });*/
      
      if (validationResult.length) {
         
         showValidationErrorsModal({
            validationResult: validationResult
         });
         
         
      } else {
         setCurrentStep(3);
      }
      
      
   }
   
   const doesRequireLicenseDate = () => {
      
      return DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST.includes(data.drivingLicenseDuration);
      
   }
   
   const shouldDisplayAdditionalDrivingQualificationDate = () => {
      
      if (!data.additionalDrivingQualifications
         || !data.additionalDrivingQualifications.trim()) {
         return false;
      }
      
      return data.additionalDrivingQualifications !== 'No';
      
   }
   
   
   return (
      <div className='if-step-2'>
         
         <SectionHeading
            text="Driving history"
         />
         
         {/*
                License type ...
            */}
         
         <div className="row">
            
            {/* What tye of license do you have? */}
            
            <ScrollableDropdownBlock
               controlName="drivingLicenseType"
               containerCssClass="col-12 py-3 "
               labelText="What type of license do you have?"
               required={true}
               options={DRIVING_LICENSE_TYPE_OPTIONS}
               selectedValues={data.drivingLicenseType}
               onChange={handlers.onControlChange}
               helpText=""
            />
         </div>
         
         {/*
                License number
            */}
         
         {data.drivingLicenseType && (
            <DrivingLicenseNumber
               data={data}
               handlers={handlers}
            />
         )}
         
         {/*
                License duration ...
            */}
         
         <div className="row">
            
            {/* How long have you held license? */}
            
            <ScrollableDropdownBlock
               controlName="drivingLicenseDuration"
               containerCssClass="col-12 py-3 "
               labelText="How long have you held license?"
               required={true}
               options={DRIVING_LICENSE_DURATION_OPTIONS}
               selectedValues={data.drivingLicenseDuration}
               onChange={handlers.onControlChange}
               helpText=""
            />
         
         </div>
         
         {doesRequireLicenseDate() && (
            
            <div className="row hidden-box">
               
               
               {/* When did you obtain your licence? */}
               
               <ScrollableCustomDateTimePickerBlock
                  containerCssClass="col-12 py-3 "
                  labelText="When did you obtain your licence?"
                  required={true}
                  controlName="drivingLicenseDate"
                  value={data.drivingLicenseDate}
                  onChange={handlers.onControlChange}
               />
            
            </div>
         
         )}
         
         
         {/*
                DVLA Medical conditions ...
            */}
         
         <div className="row">
            
            {/* Do you have any DVLA-reported medical conditions or disabilities? */}
            
            <ScrollableDropdownBlock
               controlName="dvlaMedicalConditions"
               containerCssClass="col-12 py-3 "
               labelText="Do you have any DVLA-reported medical conditions or disabilities?"
               required={true}
               options={DVLA_MEDICAL_CONDITION_OPTIONS}
               selectedValues={data.dvlaMedicalConditions}
               onChange={handlers.onControlChange}
               helpText=""
            />
         
         </div>
         
         
         {/*
                Additional license qualifications ....
            */}
         
         <div className="row">
            
            {/* Any additional driving qualifications */}
            
            <ScrollableDropdownBlock
               controlName="additionalDrivingQualifications"
               containerCssClass="col-12 py-3 "
               labelText="Any additional driving qualifications"
               required={false}
               options={ADDITIONAL_DRIVING_QUALIFICATION_OPTIONS}
               selectedValues={data.additionalDrivingQualifications}
               onChange={handlers.onControlChange}
               helpText=""
            />
         
         </div>
         
         {/*
                If additional driving qualification is not empty,
                ask for qualification date ...
            */}
         
         {shouldDisplayAdditionalDrivingQualificationDate() && (
            <div className="row hidden-box">
               
               
               {/* What date was qualification obtained? */}
               
               <ScrollableCustomDateTimePickerBlock
                  containerCssClass="col-12 py-3 "
                  labelText="What date was qualification obtained?"
                  required={shouldDisplayAdditionalDrivingQualificationDate()}
                  controlName="additionalDrivingQualificationDate"
                  value={data.additionalDrivingQualificationDate}
                  onChange={handlers.onControlChange}
               />
            
            
            </div>
         )}
         
         {/*
                Is born in UK?
            */}
         
         <div className="row">
            
            {/* Were you born in UK?  */}
            
            <ScrollableButtonGroupBlock
               containerCssClass="col-12 py-3 "
               labelText="Were you born in UK? "
               required={true}
               controlName="isBornInUk"
               options={YES_NO_CHOICE_OPTIONS}
               selectedValues={data.isBornInUk}
               onChange={handlers.onControlChange}
            />
         
         </div>
         
         {data.isBornInUk === 'No' && (
            <div className="row hidden-box">
               
               {/* When did you first arrive in the UK? */}
               
               <ScrollableCustomDateTimePickerBlock
                  containerCssClass="col-12 py-3 extra"
                  labelText="When did you first arrive in the UK?"
                  required={data.isBornInUk === 'Yes'}
                  controlName="lastDateBecameUKResident"
                  value={data.lastDateBecameUKResident}
                  onChange={handlers.onControlChange}
               />
            </div>
         )}
         
         {/*
                Other car usage ....
            */}
         
         {/*<div className="row">

                <ScrollableDropdownBlock
                    controlName="OTHER_VEHICLE_USAGE_OPTIONS"
                    containerCssClass="col-12 py-3 "
                    labelText="Use of any other cars"
                    required={true}
                    options={OTHER_VEHICLE_USAGE_OPTIONS}
                    selectedValues={data.OTHER_VEHICLE_USAGE_OPTIONS}
                    onChange={handlers.onControlChange}
                    helpText=""
                />


            </div>*/}
         
         
         <div className="row">
            
            
            {/* Do you have any unspent NON-Motoring Criminal
                        Convictions? */}
            
            <ScrollableButtonGroupBlock
               containerCssClass="col-12 py-3 extra"
               labelText="Do you have any unspent NON-Motoring Criminal
                        Convictions?"
               required={true}
               controlName="hasNonMotoringCriminalConvictions"
               options={YES_NO_CHOICE_OPTIONS}
               selectedValues={data.hasNonMotoringCriminalConvictions}
               onChange={handlers.onControlChange}
            />
            
            
            {"Yes" === data.hasNonMotoringCriminalConvictions && (
               <>
                  {/* Please specify */}
                  
                  <ScrollableTextBoxBlock
                     containerCssClass="col-12 py-3"
                     labelText="Please specify"
                     required={data.hasNonMotoringCriminalConvictions === 'Yes'}
                     controlName="nonMotoringCriminalConvictionsDetails"
                     value={data.nonMotoringCriminalConvictionsDetails}
                     onChange={handlers.onControlChange}
                     asTextArea={true}
                     inputAttrs={{
                        maxLength: 1024,
                        rows: 3
                     }}
                  />
               </>
            
            )}
         
         </div>
         
         <WizardStepButtonsBlock
            onPrevBtnClick={onPrevBtnClick}
            onNextBtnClick={onNextBtnClick}
            nextButtonAdditionalCssClass={``}
         />
      
      
      </div>
   )
}